module.exports = __webpack_public_path__ + "/images/mockup_lista-en-no-fondo.0cdb232.jpg";